import * as Sentry from '@sentry/react';
import { isNil } from 'lodash';
import React from 'react';
import { FrontendCommonConfig } from '~frontend-common/config';
import { AppError, AppErrorProps } from './app-error';

type ExtraTags = Record<string, string | number | boolean>;

interface AppErrorBoundary extends Sentry.ErrorBoundaryProps {
  /** Props passed to the default fallback component (ignored if fallback is provided) */
  defaultFallbackProps?: AppErrorProps;
  /** extra tags to be included in the Sentry exception */
  extraTags?: ExtraTags | (() => ExtraTags);
}

// Wrapper around Sentry's error boundary
// Automatically sends caught errors to Sentry
export function AppErrorBoundary({ defaultFallbackProps, extraTags, ...props }: AppErrorBoundary) {
  function extractApplicationId(): string {
    try {
      return sessionStorage.getItem('applicationId');
    } catch (e) {
      // Silently ignore
    }
  }

  return (
    <Sentry.ErrorBoundary
      onError={(error: unknown) => {
        // Prevent the little girl from eating errors during development
        if (FrontendCommonConfig.isDebugBuild) {
          // eslint-disable-next-line no-console
          console.log(error);
        }
      }}
      fallback={<AppError {...defaultFallbackProps} />}
      beforeCapture={(scope) => {
        const tags: ExtraTags = typeof extraTags === 'function' ? extraTags() : extraTags;

        if (!isNil(tags)) {
          const applicationId = extractApplicationId();
          scope.setTags({ ...tags, applicationId });
        }
      }}
      {...props}
    />
  );
}
